import { FC } from "react";
import { Chip } from "@mui/material";
import { green, grey } from "@mui/material/colors";

interface MedicallyReadyPillProps {
  isMedicallyReady: boolean;
}

/**
 * Read-only display of medically-ready status, shown in place of the toggle
 * when the status cannot be edited (read-only config / view-only). A green
 * "Ready" pill when the patient is medically ready, otherwise a muted
 * "Not Ready" pill.
 */
const MedicallyReadyPill: FC<MedicallyReadyPillProps> = ({
  isMedicallyReady,
}) => (
  <Chip
    label={isMedicallyReady ? "Ready" : "Not Ready"}
    size="small"
    variant={isMedicallyReady ? "filled" : "outlined"}
    sx={
      isMedicallyReady
        ? {
            backgroundColor: green[50],
            color: green[600],
          }
        : {
            backgroundColor: grey[50],
            color: grey[600],
            borderColor: grey[400],
          }
    }
  />
);

export default MedicallyReadyPill;
